import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './SearchResultPopup.css';

interface Props {
    anchorElementId: string;
}

const SearchResultPopup: React.FunctionComponent<Props> = props => {
    const anchor = document.getElementById(props.anchorElementId);
    if (!anchor) {
        throw new Error('Invalid anchor element ID: ' + props.anchorElementId);
    }

    const rect = anchor.getBoundingClientRect();
    const style = {
        left: rect.right,
        top: rect.top
    };

    const content = (
        <div className="SearchResultPopup" style={style}>
            {props.children}
        </div>
    );

    return ReactDOM.createPortal(content, document.body);
};

export default SearchResultPopup;
